import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { getAlumniCount } from "./-query/api";
import { SearchSchema } from "./-zod-schema";

export const Route = createFileRoute("/_staff/people/_list/alumni/")({
  validateSearch: zodValidator(SearchSchema),
  loader: getAlumniCount,
});
